import './App.css';
import VanillaReactForm from './forms/VanillaReactForm';

function App() {
  return (
    <div className="App">
      <h1>Who are you?</h1>
      <div className="form-wrapper">
        <VanillaReactForm />
      </div>
    </div>
  );
}

export default App;
